import { useQueryClient, useMutation } from "@tanstack/react-query";
import SchoolService from "../service/SchoolService";
import { useNotification } from "../context/NotificationContext";

export function useDeleteSchool() {
  const queryClient = useQueryClient();
  const { addNotification } = useNotification();

  const { mutate: deleteSchool, isLoading: isDeleting } = useMutation({
    mutationFn: (idSchool) => SchoolService.delete(idSchool),

    onSuccess: () => {
      addNotification("School deleted", "success");
      queryClient.invalidateQueries(["schools"]);
    },
    onError: (error) => {
      // Gestisci l'errore
      addNotification(error.message, "error");
      console.error("Error editing school:", error);
    },
  });

  return { deleteSchool, isDeleting };
}

/* const updateWorkData = await WorkService.update(data, id);
updateWork(updateWorkData);



function updateWork(updatedWorkData) {
    const index = data.findIndex(
      (artwork) => artwork.id === updatedWorkData.id
    );
    // Crea una copia dei dati correnti
    const newData = [...data];
    // Aggiorna l'opera d'arte nei dati
    newData[index] = updatedWorkData;
    // Aggiorna lo stato dei dati
    //setData(newData);
    localStorage.removeItem(`searchData`);
    localStorage.setItem(`searchData`, JSON.stringify(newData));


 */
